import "common/ajax_status";
import "common/customer/autofocus";
import initPrint from "common/customer/print";
import initTooltipOnLoad from "common/customer/tooltip";
import {
  isCheckIsFirstTimeVisitor,
  removeTidioChatScript
} from "common/customer/first-time-visitor";
import { getCleanPath, isProductDetailsPage } from "common/utils/detect-page-type/page-type";

document.addEventListener("DOMContentLoaded", () => {
  initPrint();
  initTooltipOnLoad();

  if (!isProductDetailsPage(getCleanPath())) {
    isCheckIsFirstTimeVisitor() && removeTidioChatScript();
  }
});
